import React from "react";
import StatusERTPage from "./views/StatusERTPage";
import { StatusERTContextProvider } from "./StatusERTView";
import StatusContents from "../../constants/contentFile.json";

const EvacuationView = () => {
  return (
    <StatusERTContextProvider>
      <StatusERTPage textContents={StatusContents.status} />
    </StatusERTContextProvider>
  );
};
export default EvacuationView;
